import AppLayout from '../components/layouts/AppLayout';
import ActivationOverviewPreviewRouterView from '../components/router-views/activation-preview/ActivationOverviewPreviewRouterView';
import ActivationTasksPreviewRouterView from '../components/router-views/activation-preview/ActivationTasksPreviewRouterView';
import ActivationProductsPreviewView from '../components/router-views/activation-preview/ActivationProductsPreviewRouterView';
import ActivationAssetsPreviewRouterView from '../components/router-views/activation-preview/ActivationAssetsPreviewRouterView';
import ActivationAgreementsPreviewRouterView from '../components/router-views/activation-preview/ActivationAgreementsPreviewRouterView';
import ActivationPaymentsPreviewRouterView from '../components/router-views/activation-preview/ActivationPaymentsPreviewRouterView';
import ActivationPersonalInfoPreviewRouterView from '../components/router-views/activation-preview/ActivationPersonalInfoPreviewRouterView';

export default {
    path:      '/activation-preview/:activation_id',
    component: AppLayout,
    children:  [
        {
            name:      'v2.activation.preview.overview',
            path:      'overview',
            component: ActivationOverviewPreviewRouterView,
        },
        {
            name:      'v2.activation.preview.tasks',
            path:      'tasks',
            component: ActivationTasksPreviewRouterView,
        },
        {
            name:      'v2.activation.preview.products',
            path:      'products',
            component: ActivationProductsPreviewView,
        },
        {
            name:      'v2.activation.preview.payments',
            path:      'payments',
            component: ActivationPaymentsPreviewRouterView,
        },
        {
            name:      'v2.activation.preview.assets',
            path:      'assets',
            component: ActivationAssetsPreviewRouterView,
        },
        {
            name:      'v2.activation.preview.info',
            path:      'personal-info',
            component: ActivationPersonalInfoPreviewRouterView,
        },
        {
            name:      'v2.activation.preview.agreement',
            path:      'agreement',
            component: ActivationAgreementsPreviewRouterView,
        },
    ],
};
